/**
 * Shop the Look - GA4 Tracking
 * Amy Atelier
 */
window.STLTracking = {
  
  getLookDataFromPage: function() {
    var el = document.querySelector('[data-stl-look-id]');
    if (el) {
      return {
        id: el.dataset.stlLookId,
        title: el.dataset.stlLookTitle,
        handle: el.dataset.stlLookHandle
      };
    }
    return null;
  },
  
  getSourceFromURL: function() {
    return new URLSearchParams(window.location.search).get('stl_source') || 'direct';
  },

  init: function() {
    var lookData = this.getLookDataFromPage();
    if (lookData && lookData.id) {
      this.trackLookView(lookData);
    }
  },

  trackLookView: function(lookData) {
    var source = this.getSourceFromURL();
    if (typeof gtag === 'function') {
      gtag('event', 'stl_look_view', {
        look_id: lookData.id,
        look_name: lookData.title,
        look_handle: lookData.handle,
        stl_source: source
      });
    }
  },
  
  trackLookClick: function(lookId, lookTitle, lookHandle, source, location) {
    if (typeof gtag === 'function') {
      gtag('event', 'stl_look_click', {
        look_id: lookId,
        look_name: lookTitle,
        look_handle: lookHandle,
        stl_source: source,
        click_location: location
      });
    }
  },

  trackProductClick: function(lookData, productId, productTitle, source) {
    if (typeof gtag === 'function') {
      gtag('event', 'stl_product_click', {
        look_id: lookData ? lookData.id : '',
        look_handle: lookData ? lookData.handle : '',
        product_id: productId,
        product_name: productTitle,
        stl_source: source || this.getSourceFromURL()
      });
    }
  },

  trackAddToCart: function(lookData, productId, variantId, productTitle, price, source) {
    if (typeof gtag === 'function') {
      gtag('event', 'stl_add_to_cart', {
        currency: 'USD',
        value: parseFloat(price) || 0,
        items: [{
          item_id: productId,
          item_name: productTitle,
          price: parseFloat(price) || 0,
          quantity: 1
        }],
        look_id: lookData ? lookData.id : '',
        look_handle: lookData ? lookData.handle : '',
        stl_source: source || this.getSourceFromURL(),
        look_attributed: true
      });
    }
  }
};